var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campus-nothing-container flex-column-center"},[_c('img',{attrs:{"src":"https://files.wondercv.com/m/calendar/no-data.png","alt":""}}),_c('span',[_vm._v(_vm._s(_vm.dealType === 'me' ? '暂无待办事项' : '暂无网申日程'))])])}
var staticRenderFns = []

export { render, staticRenderFns }